// DashboardTaskList Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import IntlMessage from '../../common/intl/intl_message.jsx'
import Dropdown from '../../form/dropdown/dropdown.jsx'
import TaskItem from '../../../task/task/task_item/task_item.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import timerStates from '../../../../shared/util/timer/timerStates.js'

class DashboardTaskList extends Component {
  static get propTypes () {
    return {
      taskGroups: PropTypes.array,
      timer: PropTypes.object.isRequired,
      loggedInUserId: PropTypes.string,
      className: PropTypes.string,
      onStart: PropTypes.func,
      onStop: PropTypes.func,
      onCompleteTask: PropTypes.func,
      onUpdateSubTasks: PropTypes.func,
      sort: PropTypes.string,
      sortAsc: PropTypes.bool,
      sortOptions: PropTypes.array,
      onToggleExpandTask: PropTypes.func,
      onClickTaskSetting: PropTypes.func,
      onPause: PropTypes.func,
      onResume: PropTypes.func,
      onAddTime: PropTypes.func,
      stopAndCreateNewTimeCard: PropTypes.func,
      showInfoIcon: PropTypes.bool,
      onClickTask: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      taskGroups: null,
      loggedInUserId: null,
      className: '',
      onStart: null,
      onStop: null,
      onCompleteTask: null,
      onUpdateSubTasks: null,
      sort: null,
      sortAsc: true,
      sortOptions: [],
      onToggleExpandTask: null,
      onClickTaskSetting: null,
      onPause: null,
      onResume: null,
      onAddTime: null,
      stopAndCreateNewTimeCard: null,
      showInfoIcon: false,
      onClickTask: null
    }
  }

  render () {
    return (
      <div
        className={`dashboard-tasklist${
          this.props.className ? ' ' + this.props.className : ''
        }`}
      >
        {this._renderTaskGroups()}
      </div>
    )
  }

  /* Event Handler */
  _onSort (taskgroup, ident) {
    let bAsc = true
    if (ident === 'datedesc') {
      bAsc = false
    }

    taskgroup.tasks = _.sortBy(taskgroup.tasks, obj => {
      return obj.nearestScheduleDate ? new Date(obj.nearestScheduleDate) : null
    })

    if (!bAsc) {
      taskgroup.tasks.reverse()
    }

    taskgroup.sortBy = ident
    taskgroup.sortAsc = bAsc
    this.setState({ dataDate: new Date() })
  }

  /* Private Function */
  _renderTaskGroups () {
    const taskGroups = this.props.taskGroups
    if (taskGroups && taskGroups.length > 0) {
      return taskGroups.map((taskgroup, idx) => {
        if (taskgroup.tasks.length > 0) {
          let titleIdent = 'common.list.tasksLater'
          let showInfoIcon = false
          let className = 'title'
          var amountOfTasks = taskgroup.tasks.length

          if (taskgroup.date === 'today') {
            if (amountOfTasks === 1) {
              titleIdent = 'common.list.taskToday'
            } else {
              titleIdent = 'common.list.tasksToday'
            }
          } else if (taskgroup.date === 'week') {
            if (amountOfTasks === 1) {
              titleIdent = 'common.list.taskWeek'
            } else {
              titleIdent = 'common.list.tasksWeek'
            }
          } else if (taskgroup.date === 'critical') {
            titleIdent = 'common.list.tasksCritical'
          } else if (taskgroup.date === 'blocker') {
            titleIdent = 'common.list.tasksInRisk'
            showInfoIcon = true
            className = `${className} info`
          } else if (taskgroup.date === 'overdue') {
            titleIdent = 'common.list.tasksOverdue'
          } else if (taskgroup.date === 'all') {
            titleIdent = 'common.list.tasksAll'
          }

          return (
            <div className='taskgroup' key={idx}>
              <div className='taskdate'>
                <div className={className}>
                  <span className='count'>{taskgroup.tasks.length} </span>
                  <IntlMessage ident={titleIdent} />
                </div>
                {showInfoIcon && (
                  <IconButton
                    icon='common-listinfo'
                    size='small'
                    canHover
                    className='taskinfo'
                    tooltipPosition='top'
                    tooltip='common.list.taskInfo'
                  />
                )}
                <div className='sort'>
                  <span className='label'>
                    <IntlMessage ident='common.list.sortByLabel' />
                  </span>
                  <span className='values'>
                    <Dropdown
                      source={this.props.sortOptions}
                      name='sortBy'
                      label='common.list.sortByLabel'
                      className='gridsort-dropdown'
                      value={taskgroup.sortBy || 'dateasc'}
                      onChange={this._onSort.bind(this, taskgroup)}
                    />
                  </span>
                </div>
              </div>
              <div className='tasklist'>
                {this._renderTaskItems(taskgroup.tasks)}
              </div>
            </div>
          )
        }

        return ''
      })
    }

    return ''
  }

  _renderTaskItems (tasks) {
    if (tasks) {
      const timer = this.props.timer
      return tasks.map((task, _idx) => {
        const status = timer.doesRelateToTaskId(task.id) ? timer.Status() : timerStates.NONE
        return (
          <TaskItem
            key={task.id}
            task={task}
            status={status}
            timer={timer}
            loggedInUserId={this.props.loggedInUserId}
            onAddTime={this.props.onAddTime}
            onStart={this.props.onStart}
            onPause={this.props.onPause}
            onResume={this.props.onResume}
            onCompleteTask={this.props.onCompleteTask}
            onUpdateSubTasks={this.props.onUpdateSubTasks}
            onToggleExpand={this.props.onToggleExpandTask}
            onClickSetting={this._onItemSettingClick.bind(this)}
            stopAndCreateNewTimeCard={this.props.stopAndCreateNewTimeCard}
            onClick={this.props.onClickTask}
          />
        )
      })
    }

    return ''
  }

  _onItemSettingClick (task) {
    if (this.props.onClickTaskSetting) {
      this.props.onClickTaskSetting(task)
    }
  }
}

export default DashboardTaskList
